import styled from 'styled-components';

export const ImgStore = styled.img`
    padding: 10px;
    margin: 10px;
    border-radius: 15px;
    width: 90%;
    @media screen and (max-width: 768px){
        width:100%;
    }
    `;